import { getAuthHeaders } from './authHeaders';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

class ShipmentsAPI {
  static async getShipment(orderCode) {
    const headers = await getAuthHeaders();
    const response = await fetch(`${API_BASE_URL}/shipments/${encodeURIComponent(orderCode)}`, {
      headers,
    });

    if (!response.ok) {
      if (response.status === 401) {
        throw new Error('NOT_AUTHENTICATED');
      }
      if (response.status === 404) {
        const err = new Error('SHIPMENT_NOT_FOUND');
        err.status = 404;
        throw err;
      }
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    return await response.json();
  }

  static async createShipment({ orderCode, deliveryOptionId = null, otoOrderPayload = null }) {
    const headers = await getAuthHeaders({
      'Content-Type': 'application/json',
    });

    const body = {
      order_code: orderCode,
    };

    if (deliveryOptionId) {
      body.delivery_option_id = deliveryOptionId;
    }

    if (otoOrderPayload) {
      body.oto_order_payload = otoOrderPayload;
    }

    const response = await fetch(`${API_BASE_URL}/shipments`, {
      method: 'POST',
      headers,
      body: JSON.stringify(body),
    });

    if (!response.ok) {
      if (response.status === 401) {
        throw new Error('NOT_AUTHENTICATED');
      }
      let details = '';
      try {
        details = await response.text();
      } catch (_) {}
      const err = new Error(`HTTP error! status: ${response.status}`);
      err.details = details;
      throw err;
    }

    return await response.json();
  }

  static async refreshTracking({ orderCode, deliveryCompanyName, statusHistory = false }) {
    const headers = await getAuthHeaders({
      'Content-Type': 'application/json',
    });

    const response = await fetch(`${API_BASE_URL}/shipments/${encodeURIComponent(orderCode)}/refresh`, {
      method: 'POST',
      headers,
      body: JSON.stringify({
        delivery_company_name: deliveryCompanyName,
        status_history: statusHistory,
      }),
    });

    if (!response.ok) {
      if (response.status === 401) {
        throw new Error('NOT_AUTHENTICATED');
      }
      let details = '';
      try {
        details = await response.text();
      } catch (_) {}
      const err = new Error(`HTTP error! status: ${response.status}`);
      err.details = details;
      throw err;
    }

    return await response.json();
  }
}

export default ShipmentsAPI;
